import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TopNav = _resolveComponent("TopNav");

  const _component_SwpierTop = _resolveComponent("SwpierTop");

  const _component_IconList = _resolveComponent("IconList");

  const _component_MusicList = _resolveComponent("MusicList");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_TopNav), _createVNode(_component_SwpierTop), _createVNode(_component_IconList), _createVNode(_component_MusicList)], 64);
}